import makeApiRequest from '../../api/makeApiCall';
import { Config } from '../../latest/src/constants/AppServerConfig';

const THERAPY_SESSION_URL = Config.therapySessionService;

export const postTherapySessionStart = async(data:object) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}therapy-sessions`, 'POST', data);
};

export const getClusterList = async(id:string, offset:Number, limit:Number) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}clusters?${id ? ('therapist_id='+id+'&') :''}limit=${limit}&offset=${offset}&size=M`, 'GET');
};

export const getClusterClientList = async(id:string, offset:Number, limit:Number) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}clusters?${id ? ('client_id='+id+'&') :''}limit=${limit}&offset=${offset}&size=M`, 'GET');
};

export const updateClusterStatus = async (type:UserType, cluster:Object) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}clusters/${cluster[0].id}`, 'PATCH', cluster[0]);
};

export const getActiveRunningSession = async() => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}therapy-sessions`, 'GET');
};

// THIS IS RESILIENT API
export const getClientIsActiveInSession = async(data:object) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}therapy-sessions/${data.therapySessionID}/_client-active-in-session`, 'PUT',{},'','',true);
};

// RESILIENT API
export const getTherapistIsActiveInSession = async(data:object) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}therapy-sessions/${data.therapySessionID}/_therapist-active-in-session`, 'PUT',{},'','',true);
};

// Adding New API to call Image Temporarily 
// ==============================================
// RESILIENT API
export const getClientIsActive = async(data:object) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}therapy-sessions/${data.therapySessionID}/_client-active-in-waiting-room`, 'PUT',{},'','',true);
};

// resilient api
export const getChimeJoinData = async(therapySessionID:string) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}therapy-sessions/${therapySessionID}/_get-chime-join-data`, 'GET',{},'','',true);
};


export const sendMeetingMetrics = async(data:object) => {
    return await makeApiRequest(`${THERAPY_SESSION_URL}therapy-sessions/_send-stats`, 'PUT',data,'','',true);
};